<template>
  <v-main class="main-wrapper">
    <loader :loading="$auth.loading" />
    <base-header :links="links" />
    <v-container class="main-container">
      <v-row>
        <v-col>
          <slot />
        </v-col>
      </v-row>
    </v-container>
    <dialogs-container />
    <snackbars-container />
    <scroll-to-top />
  </v-main>
</template>

<script>
import BaseHeader from "@/components/base/Header.vue";
import DialogsContainer from "@/components/dialog/DialogsContainer.vue";
import SnackbarsContainer from "@/components/snackbar/SnackbarsContainer.vue";
import Loader from "@/components/base/Loader.vue";
import ScrollToTop from "../components/base/ScrollToTop.vue";

export default {
  name: "CompanyAdmin",
  components: {
    ScrollToTop,
    Loader,
    BaseHeader,
    DialogsContainer,
    SnackbarsContainer,
  },
  computed: {
    links() {
      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.main-wrapper {
  background-color: $preston-color-light-grey;
}

.main-container {
  padding: 16px 16px 64px 16px;

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    padding-top: 32px;
  }
}
</style>
